(function () {
  function init() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    var saved = null;
    function sync() {
      var current = grid.querySelector('.easysearch-block-container');
      if (current) { saved = current; return; } // remember the live widget node
      if (!saved) return;
      var slot = grid.querySelector('.easysearch-embed-widget-main');
      // section render returns the wrapper empty — put the saved node back
      if (slot && !slot.querySelector('.easysearch-block-container')) slot.appendChild(saved);
    }
    sync();
    new MutationObserver(sync).observe(grid, { childList: true, subtree: true });
  }
  // Run only when the EasySearch form has actually been rendered;
  // if the app is removed, the event never fires and nothing is set up.
  if (window.easysearch && window.easysearch.eventStates && window.easysearch.eventStates.easysearch_rendered) init();
  else document.addEventListener('easysearch_rendered', init, { once: true });
})();